export default __webpack_public_path__ + "assets/images/e79820fe402fa92c91c04a7d9723c340.png";